import React from 'react';

interface ProgressBarProps {
  /** 0 a 100. Valor fora da faixa (ou NaN) é aparado. */
  valor: number;
  /** Altura e raio da trilha. */
  className?: string;
  /** Cor da barra. Aceita gradiente. */
  barraClassName?: string;
  /** Quanto dura o avanço. O cronômetro da etapa usa duration-1000 (tique de 1s). */
  duracaoClassName?: string;
  /** Rótulo para leitor de tela, quando a barra não tem texto ao lado. */
  label?: string;
}

/**
 * Barra de progresso. Substitui as cinco cópias do mesmo markup que existiam em
 * QuizProgress, RoutineChecklistHeader, RoutineChecklist, SkinProgress e AdminBilling.
 *
 * Anima `transform: scaleX()` e **não** `width`: largura é propriedade de layout
 * e faz o navegador refazer o cálculo a cada frame.
 *
 * ponytail: com gradiente, o scaleX estica o degradê em vez de revelá-lo. Em
 * nenhuma das telas de hoje isso incomoda; se um dia incomodar, o degradê sobe
 * para a trilha e a barra vira máscara.
 */
export default function ProgressBar({
  valor,
  className = 'h-1.5',
  barraClassName = 'bg-blush-500',
  duracaoClassName = 'duration-500',
  label,
}: ProgressBarProps) {
  const pct = Math.min(100, Math.max(0, Number.isFinite(valor) ? valor : 0));

  return (
    <div
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
      className={`w-full overflow-hidden rounded-full bg-nude-100 dark:bg-gray-700 ${className}`}
    >
      <div
        className={`h-full w-full origin-left rounded-full transition-transform ease-soft ${duracaoClassName} ${barraClassName}`}
        style={{ transform: `scaleX(${pct / 100})` }}
      />
    </div>
  );
}
